<template>
  <div class="app-container">
    <!-- 顶部导航栏 -->
    <!-- <div class="page-header">
      <img src="@/assets/nav/yz_nav_fh_w.png" alt="返回" class="back-icon" @click="goBack">
      <h1>排名奖励及说明</h1>
    </div> -->

    <!-- 内容区域 -->
    <div class="content-area">
      <!-- 排名奖励说明内容 -->
      <div class="reward-content">
        <div class="section">
          <h2>周囤币榜奖励</h2>
          <div class="reward-item">
            <div class="rank-number">1</div>
            <div class="reward-details">
              <p class="reward-name">榜单页面展示为上周一至周日排名</p>
            </div>
          </div>
          <div class="reward-item">
            <div class="rank-number">2</div>
            <div class="reward-details">
              <p class="reward-name">榜单周一0点更新,统计上周累充值</p>
            </div>
          </div>
          <div class="reward-item">
            <div class="rank-number">3</div>
            <div class="reward-details">
              <p class="reward-name">累长值可在钱包页面或囤币活动页面获得</p>
            </div>
          </div>
          <div class="reward-item">
            <div class="rank-number">4</div>
            <div class="reward-details">
              <p class="reward-name">排名称号奖励将在上周榜单结束后自动发放</p>
            </div>
          </div>
          <div class="reward-item">
            <div class="rank-number">5</div>
            <div class="reward-details">
              <p class="reward-name">称号有效期为7天,可在个人中心-个性装扮处开启展示</p>
            </div>
          </div>
          <img src="@/assets/vip/tbchsm.png" alt="" class="tbchsm">
        </div>

        <div class="section">
          <h2>周活跃榜奖励(积分成长值)</h2>
          <div class="reward-item">
            <div class="rank-number">1</div>
            <div class="reward-details">
              <p class="reward-name">榜单页面展示为上周一至周日排名</p>
            </div>
          </div>
          <div class="reward-item">
            <div class="rank-number">2</div>
            <div class="reward-details">
              <p class="reward-name">榜单周一0点更新,统计上周获取的成长值</p>
            </div>
          </div>
          <div class="reward-item">
            <div class="rank-number">3</div>
            <div class="reward-details">
              <p class="reward-name">积分成长值可在主页签到界面或社区等活动获得</p>
            </div>
          </div>
          <div class="reward-item">
            <div class="rank-number">4</div>
            <div class="reward-details">
              <p class="reward-name">消耗积分兑换余额不会扣除对应成长值</p>
            </div>
          </div>
          <div class="reward-item">
            <div class="rank-number">5</div>
            <div class="reward-details">
              <p class="reward-name">排名称号奖励将在上周榜单结束后自动发放</p>
            </div>
          </div>
          <div class="reward-item">
            <div class="rank-number">6</div>
            <div class="reward-details">
              <p class="reward-name">称号有效期为7天,可在个人中心-个性装扮处开启展示</p>
            </div>
          </div>
          <img src="@/assets/vip/hychsm.png" alt="" class="tbchsm">
          <img src="@/assets/vip/czzsm.png" alt="" class="tbchsm">
        </div>

        <div class="section">
          <h2>总积分榜奖励(积分成长值)</h2>
          <div class="reward-item">
            <div class="rank-number">1</div>
            <div class="reward-details">
              <p class="reward-name">页面排名按照玩家创建账号开始计算获得的总积分数</p>
            </div>
          </div>
          <div class="reward-item">
            <div class="rank-number">2</div>
            <div class="reward-details">
              <p class="reward-name">头衔长期有效，按照获取的成长值展示对应的标签</p>
            </div>
          </div>
          <img src="@/assets/vip/djsm.png" alt="" class="tbchsm">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';
export default {
  name: 'RankReward',
  setup() {
    const router = useRouter();

    // 返回方法
    const goBack = () => {
      router.back();
    };

    return {
      goBack
    };
  }
};
</script>

<style scoped>
.app-container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(to bottom, #1a1a2e, #16213e);
  overflow-x: hidden;
  padding-top: calc(20px + env(safe-area-inset-top));
  padding-top: calc(20px + constant(safe-area-inset-top));
}

/* 顶部导航栏样式 */
.page-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  box-sizing: border-box;
  /* 为固定顶部导航栏添加安全区域适配 */
  padding-top: calc(20px + env(safe-area-inset-top));
  padding-top: calc(20px + constant(safe-area-inset-top));
  background-color: rgba(26, 26, 46, 0.8);
  backdrop-filter: blur(10px);
}

/* 返回按钮样式 */
.back-icon {
  position: absolute;
  left: 32px;
  width: 60px;
  height: 60px;
}

.page-header h1 {
  font-size: 32px;
  color: #fff;
  margin: 0;
  text-align: center;
}

/* 内容区域样式 */
.content-area {
  width: 100%;
  padding-top: 20px;
  /* 为顶部导航栏留出空间 */
  padding-bottom: 40px;
}

.reward-content {
  width: 90%;
  margin: 0 auto;
}

.section {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 30px;
  margin-bottom: 30px;
  backdrop-filter: blur(5px);
}

.section h2 {
  font-size: 28px;
  color: #ffffff;
  margin-bottom: 20px;
  text-align: center;
  border-bottom: 2px solid #ffd8ab;
  padding-bottom: 15px;
}

.tbchsm {
  width: 100%;
  height: 100%;
  margin-top: 20px;
}

.reward-item {
  display: flex;
}

.reward-item:last-child {
  border-bottom: none;
}

.rank-number {
  width: 30px;
  height: 30px;
  background: linear-gradient(135deg, #ffd8ab, #ffb703);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: bold;
  color: #2a2930;
  margin-right: 20px;
}

.reward-details {
  flex: 1;
}

.reward-name {
  font-size: 24px;
  color: #ffffff;
  margin-bottom: 8px;
}

/* 规则说明样式 */
.rules-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.rules-list li {
  font-size: 20px;
  color: #ffffff;
  line-height: 1.6;
  margin-bottom: 15px;
  position: relative;
  padding-left: 30px;
}

.rules-list li::before {
  content: "•";
  position: absolute;
  left: 0;
  color: #ffd8ab;
  font-size: 28px;
  line-height: 1;
}

.rules-list li:last-child {
  margin-bottom: 0;
}
</style>